// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.villasCard {
  max-width: 25rem;
  background: var(--clr-light);
  border-radius: 1em;
  overflow: hidden;
  cursor: pointer;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);
}

.villasCard__container {
  padding: 1.5em;
}

.villasCard__img {
  width: 100%;
  height: 15rem;
  object-fit: cover;
  position: relative;
  z-index: 2;
}

.villasCard__imgContainer {
  background-color: var(--clr-gray300);
  width: 100%;
  height: 15rem;
  overflow: hidden;
  position: relative;
}

.villasCard__imgContainer::after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.74),
    transparent
  );

  animation: loadingSkeleton 0.8s infinite;
}

.villasCard__details {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
  /* justify-content: space-between; */
  /* justify-content: center; */
}
.villasCard__details > div {
  display: flex;
  align-items: center;
}

.villasCard__details span {
  color: var(--clr-primary);
  margin-left: 0.25rem;
  font-size: 0.8rem;
  font-weight: bold;
  white-space: nowrap;
}

.villasCard__details svg {
  display: block;
  width: 1rem;
}

.villasCard__distanceTime {
  display: block;
  font-size: 0.8rem;
  font-weight: bold;
  margin: 0.5rem 0 0.75rem 0;
}

.villasCard__title {
  font-weight: bolder;
  font-size: 1.25rem;
  color: var(--clr-primary);
}

.villasCard__description {
  margin: 0.5rem 0;
  line-height: 1.6;
}

.villasCard__rating {
  display: flex;
  align-items: center;
}

.villasCard__rating svg {
  display: block;
  width: 1.25rem;
  margin-top: -0.15rem;
  margin-right: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/VillasComponents/VillasCard/VillasCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yDAAyD;EACzD,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4BAA4B;EAS5B;;;;;GAKC;;EAED,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB","sourcesContent":[".villasCard {\n  max-width: 25rem;\n  background: var(--clr-light);\n  border-radius: 1em;\n  overflow: hidden;\n  cursor: pointer;\n  -webkit-mask-image: -webkit-radial-gradient(white, black);\n  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);\n}\n\n.villasCard__container {\n  padding: 1.5em;\n}\n\n.villasCard__img {\n  width: 100%;\n  height: 15rem;\n  object-fit: cover;\n  position: relative;\n  z-index: 2;\n}\n\n.villasCard__imgContainer {\n  background-color: var(--clr-gray300);\n  width: 100%;\n  height: 15rem;\n  overflow: hidden;\n  position: relative;\n}\n\n.villasCard__imgContainer::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: translateX(-100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(transparent),\n    color-stop(rgba(255, 255, 255, 0.74)),\n    to(transparent)\n  );\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.74),\n    transparent\n  );\n\n  animation: loadingSkeleton 0.8s infinite;\n}\n\n.villasCard__details {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.25rem;\n  /* justify-content: space-between; */\n  /* justify-content: center; */\n}\n.villasCard__details > div {\n  display: flex;\n  align-items: center;\n}\n\n.villasCard__details span {\n  color: var(--clr-primary);\n  margin-left: 0.25rem;\n  font-size: 0.8rem;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.villasCard__details svg {\n  display: block;\n  width: 1rem;\n}\n\n.villasCard__distanceTime {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: bold;\n  margin: 0.5rem 0 0.75rem 0;\n}\n\n.villasCard__title {\n  font-weight: bolder;\n  font-size: 1.25rem;\n  color: var(--clr-primary);\n}\n\n.villasCard__description {\n  margin: 0.5rem 0;\n  line-height: 1.6;\n}\n\n.villasCard__rating {\n  display: flex;\n  align-items: center;\n}\n\n.villasCard__rating svg {\n  display: block;\n  width: 1.25rem;\n  margin-top: -0.15rem;\n  margin-right: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
